import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  RollupCategoryDetail,
  RollupResponseCategoriesResponse,
  RollupSituationCategoriesResponse,
  RollupTaxonomiesResponse,
} from '../../shared/models/rollup.models';
import { PageParams } from '../../shared/models/pagination.models';

@Injectable({ providedIn: 'root' })
export class RollupService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  // ── Rollup Response Categories ────────────────────────────────────────────

  getRollupResponseCategories() {
    return this.http.get<RollupResponseCategoriesResponse>(
      `${this.apiUrl}/api/rollup-response-categories`,
    );
  }

  getRollupResponseCategoryById(id: string) {
    return this.http.get<RollupCategoryDetail>(
      `${this.apiUrl}/api/rollup-response-categories/${id}`,
    );
  }

  createRollupResponseCategory(payload: { name: string; definition: string }) {
    return this.http.post<RollupCategoryDetail>(
      `${this.apiUrl}/api/rollup-response-categories`,
      payload,
    );
  }

  updateRollupResponseCategory(payload: RollupCategoryDetail) {
    return this.http.put<RollupCategoryDetail>(
      `${this.apiUrl}/api/rollup-response-categories`,
      payload,
    );
  }

  deleteRollupResponseCategory(id: string) {
    return this.http.delete<void>(`${this.apiUrl}/api/rollup-response-categories/${id}`);
  }

  // ── Rollup Situation Categories ───────────────────────────────────────────

  getRollupSituationCategories() {
    return this.http.get<RollupSituationCategoriesResponse>(
      `${this.apiUrl}/api/rollup-situation-categories`,
    );
  }

  getRollupSituationCategoryById(id: string) {
    return this.http.get<RollupCategoryDetail>(
      `${this.apiUrl}/api/rollup-situation-categories/${id}`,
    );
  }

  createRollupSituationCategory(payload: { name: string; definition: string }) {
    return this.http.post<RollupCategoryDetail>(
      `${this.apiUrl}/api/rollup-situation-categories`,
      payload,
    );
  }

  updateRollupSituationCategory(payload: RollupCategoryDetail) {
    return this.http.put<RollupCategoryDetail>(
      `${this.apiUrl}/api/rollup-situation-categories`,
      payload,
    );
  }

  deleteRollupSituationCategory(id: string) {
    return this.http.delete<void>(`${this.apiUrl}/api/rollup-situation-categories/${id}`);
  }

  // ── Rollup Taxonomies ─────────────────────────────────────────────────────

  getRollupTaxonomies(params?: PageParams) {
    let httpParams = new HttpParams();
    if (params) {
      if (params.pageSize != null) httpParams = httpParams.set('pageSize', params.pageSize);
      if (params.pageIndex != null) httpParams = httpParams.set('pageIndex', params.pageIndex);
      if (params.filter != null) httpParams = httpParams.set('filter', params.filter);
    }
    return this.http.get<RollupTaxonomiesResponse>(`${this.apiUrl}/api/rollup-taxonomies`, {
      params: httpParams,
    });
  }
}
